export enum TokenSortMethod {
  POOLS = 'Pools',
  TOTAL_REWARDS = 'Total Rewards',
  TOTAL_VOTES = 'Total Votes',
  MY_VOTE = 'My Vote',
  EARN = 'Earn',
}
